// extracted by mini-css-extract-plugin
export default {"row":"metapackage__row","preview-content":"metapackage__preview-content","vertical-list":"metapackage__vertical-list"};